import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { DATE_PICKER_Z_INDEX } from '../constants';

export const DatePickerBackground = styled.div`
  background-color: ${colors.white};
  border-radius: ${spacing.half};
  color: ${colors.textPrimary};
  margin-top: ${spacing.quarter};
  position: absolute;
  top: 100%;
  right: 0;
  z-index: ${DATE_PICKER_Z_INDEX};
`;

export const DatePickerWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: ${spacing.threeQuarter};
`;
